import { CustomClients } from '@thehubz/shared/branding';
import { arvalFilterFormData } from './arval/arval-metadata-config';
import { lufthansaFilterFormData } from './lufthansa/lufthansa-filter-form-data';
import { seatFilterFormData } from './seat/seat-filter-form-data';
import { vkbFilterFormData } from './vkb/vkb-filter-form-data';
import { vorwerkFilterFormData } from './vorwerk/vorwerk-filter-form-data';

export function customerAssetFilters(brandingKey?: string) {
  if (brandingKey === CustomClients.Arval) {
    return arvalFilterFormData;
  }
  if (brandingKey === CustomClients.Vorwerk) {
    return vorwerkFilterFormData;
  }
  if (brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge) {
    return lufthansaFilterFormData;
  }
  if (brandingKey === CustomClients.VKB) {
    return vkbFilterFormData;
  }
  if (brandingKey === CustomClients.SEAT) {
    return seatFilterFormData;
  }
  return undefined;
}
